module.exports = __webpack_public_path__ + "static/undraw_visual_data_b1wx-0a29ddde32a968aa160a989e3e411adb.svg";